module.exports = __webpack_public_path__ + "img/no_pict.5a8b77ff.png";